// extracted by mini-css-extract-plugin
export var dropdownButton = "_3m-0";
export var fullWidthDropdownButton = "_3m-1";
export var icon = "_3m-3";
export var iconPlaceholder = "_3m-2";
export var menuItemRow = "_3m-8";
export var separator = "_3m-c";
export var shortcutContainer = "_3m-7";
export var shortcutIconLg = "_3m-6";
export var shortcutIconMd = "_3m-5";
export var shortcutIconSm = "_3m-4";
export var submenuChevron = "_3m-b";
export var submenuDropdown = "_3m-9";
export var submenuTriggerRow = "_3m-a";